<template>
  <div>
    <v-dialog
      v-model="globalDialog"
      min-width="600"
      :max-width="maxWidth"
      persistent
    >
      <v-card>
        <v-card-title
          :style="{
            color: getThemeColor,
          }"
          class="text-h5 lighten-2"
          >{{ title }}</v-card-title
        >

        <v-card shaped elevation="12" outlined class="mx-10">
          <slot></slot>
        </v-card>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="closeGlobalDialogSlot()"
            >Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: "Title",
    },
    dialog: {
      default: false,
    },
    maxWidth: {
      default: "600",
    },
  },
  mounted() {
    this.globalDialog = this.dialog;
  },
  watch: {
    dialog(newVal) {
      this.globalDialog = newVal;
    },
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getGlobalDialogSlot() {
      return this.$store.getters.getGlobalDialogSlot;
    },
  },
  data: () => ({
    globalDialog: false,
  }),
  methods: {
    closeGlobalDialogSlot() {
      this.$emit("close-dialog");
    },
  },
};
</script>

<style></style>
